enum HandSellType {
  CHARGE_NOW = 'CHARGE_NOW',
  CHARGE_LATER = 'CHARGE_LATER',
  EMAIL = 'EMAIL',
  SMS = 'SMS',
}

export default HandSellType;
